module.exports = __webpack_public_path__ + "img/globe.4a63b055.png";